<template lang="html">
    <div id="verifyOtpWrap">
        <div v-if="!submitSuccess">
            <p><strong>{{ submitSuccessMessage }}</strong></p>

            <p>We've just sent a verification code to your verified phone number.</p>

            <p>Please enter the code below.</p>

            <div v-if="submitError" mb-3>
                <div class="alert alert-danger">
                    {{ submitErrorMessage }}
                </div>
            </div>

            <div class="mt-4">
                <form class="form" @submit.prevent="submitCode">
                    <div class="form-group row">
                        <div class="col-md-4 offset-md-4 col-12">
                            <label for="smsCodeLabel" class="form-label fw-bold">Verification Code:</label>
                            <input type="text" class="form-control asterisk" name="sms_code" id="smsCodeLabel" placeholder="Code" autocomplete="off" v-model="code" maxlength="5">
                        </div>
                    </div>
                    <div class="form-group my-3">
                        <button type="submit" class="btn-theme-sm" :disabled="!valid4Submit">Submit</button>
                    </div>
                </form>

                <transition name="slide">
                    <!-- <div v-if="submitLogSuccess" class="row">
                        <div class="col-12 mb-4 mt-2">
                            <span class="alert alert-success"> {{ submitLogSuccessMessage }} </span>
                        </div>
                    </div> -->
                    <div v-if="showLogFailHelp" class="row">
                        <div class="col-12 mb-4 mt-2">
                            <span style="display:inline-block;" class="alert alert-warning"><i class="far fa-question-circle mr-1"></i> Having troubles getting your verification code? <a href="#" @click.prevent="showLogFailOptions = true"><u><strong>Click here</strong></u></a></span>
                        </div>
                        <div v-if="submitLogError" class="col-12 mb-4 mt-2">
                            <span class="alert alert-danger"> {{ submitLogErrorMessage }} </span>
                        </div>
                        <div v-if="showLogFailOptions" class="col-md-6 offset-md-3 col-12 mt-2">
                            <h6><strong>What's the issue?</strong></h6>
                            <form @submit.prevent="logOtpFail" id="logOtpFailForm">
                                <div class="form-check text-start mb-1">
                                  <input class="form-check-input" type="radio" name="failReasonRadio1" id="failReasonRadio1" value="1" v-model="reason">
                                  <label class="form-check-label" for="failReasonRadio1">
                                    I don't have my mobile phone with me
                                  </label>
                                </div>
                                <div class="form-check text-start mb-1">
                                  <input class="form-check-input" type="radio" name="failReasonRadio2" id="failReasonRadio2" value="2" v-model="reason">
                                  <label class="form-check-label" for="failReasonRadio2">
                                    I never received the code
                                  </label>
                                </div>
                                <div class="form-check text-start mb-1">
                                  <input class="form-check-input" type="radio" name="failReasonRadio3" id="failReasonRadio3" value="3" v-model="reason">
                                  <label class="form-check-label" for="failReasonRadio3">
                                    Other: Please describe
                                  </label>
                                </div>
                                <div v-if="showReasonOther" class="form-group mt-3">
                                    <textarea class="form-control" name="reason_other" id="reasonOtherText" rows="3" v-model="reasonOther"></textarea>
                                    <small v-if="reasonOtherError" class="text-danger"><strong>*The reason description is required.</strong></small>
                                  </div>
                                  <div class="form-group mt-3">
                                      <button type="submit" class="btn-theme-sm">Send</button>
                                  </div>
                            </form>
                        </div>
                    </div>
                </transition>

            </div>
        </div>
        <div v-else>
            <div class="alert alert-success">
                Your identity has been succesfully verified. Please stand by while you get redirected.
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['phone', 'trackkey'],
    data() {
        return {
            code : '',
            reason : 0,
            reasonOther : "",
            reasonOtherError : false,
            showReasonOther : false,
            submitSuccess : false,
            submitSuccessMessage : "",
            submitError : false,
            submitErrorMessage : "",
            submitLogSuccess : false,
            submitLogSuccessMessage : false,
            submitLogError : false,
            submitLogErrorMessage : false,
            showLogFailHelp : false,
            showLogFailOptions : false,
        }
    },
    computed: {
        valid4Submit() {
            return this.code.length < 5 ? false : true;
        }
    },
    watch: {
        reason() {
            if(this.reason == 3) {
                this.showReasonOther = true;
            } else {
                this.showReasonOther = false;
                this.reasonOtherError = false;
                this.reasonOther = "";
            }
        }
    },
    methods: {

        submitCode() {
            const that = this;

            this.$emit('loading', { loading : true });

            const url = '/verify-otp/' + this.trackkey;

            axios
                .post(url, { code : that.code })
                .then(
                    response => {
                        switch (parseInt(response.data.response_code)) {
                            case 1:
                                that.submitError = false;
                                that.submitErrorMessage = "";
                                that.submitSuccessMessage = typeof response.data.response_text != 'undefined' ? response.data.response_text : "The correct verification code was entered.";
                                that.submitSuccess = true;
                                setTimeout(function () {
                                    window.location.replace(that.$parent.baseUrl + "/apply");
                                    // window.location = that.$parent.baseUrl + "/apply";
                                }, 3000);
                                break;
                            case 2:
                                that.submitSuccess = false;
                                that.submitSuccessMessage = "";
                                that.submitError = true;
                                that.submitErrorMessage = typeof response.data.response_text != 'undefined' ? response.data.response_text : "Invalid verification code entered.";
                            break;
                            default:
                                that.submitError = true;
                                that.submitErrorMessage = typeof response.data.response_text != 'undefined' ? response.data.response_text : "We were unable to processes your input.";

                                setTimeout(function () {
                                    window.location.replace(that.$parent.baseUrl + "/apply");
                                    // window.location = that.$parent.baseUrl + "/apply";
                                }, 3000);
                        }

                        this.$emit('loading', { loading : false });

                        VueScrollTo.scrollTo('#verifyOtpWrap', 500)
                    }
                );
        },
        logOtpFail() {
            const that = this;

            let postData = { reason : this.reason };

            if(this.reason == 3) {
                if(this.reasonOther.length == 0) {
                    this.reasonOtherError = true;
                    return;
                } else {
                    this.reasonOtherError = false;
                }
                postData.reason_other = this.reasonOther;
            }

            this.$emit('loading', { loading : true });

            const url = '/log-otp-fail/' + this.trackkey;

            axios
                .post(url, postData)
                .then(
                    response => {
                        switch (parseInt(response.data.response_code)) {
                            case 1:
                                that.submitLogError = false;
                                that.submitLogErrorMessage = "";
                                that.submitLogSuccessMessage = typeof response.data.response_text != 'undefined' ? response.data.response_text : "Thank you for your feedback. We'll try to verify your identity another way. Please stand by.";
                                that.submitLogSuccess = true;
                                that.showLogFailHelp = false;
                                setTimeout(function () {
                                    window.location = "/status/" + that.trackkey;
                                }, 3000);
                                break;
                            case 2:
                                that.submitLogSuccess = false;
                                that.submitLogSuccessMessage = "";
                                that.submitLogError = true;
                                that.submitLogErrorMessage = typeof response.data.response_text != 'undefined' ? response.data.response_text : "An error occured while sending your feedback.";
                            break;
                            default:
                                that.submitLogError = true;
                                that.submitLogErrorMessage = typeof response.data.response_text != 'undefined' ? response.data.response_text : "We were unable to processes your request.";

                                setTimeout(function () {
                                    window.location = that.$parent.baseUrl + "/apply";
                                }, 3000);
                        }

                        this.$emit('loading', { loading : false });

                        VueScrollTo.scrollTo('#verifyOtpWrap', 500)
                    }
                );
        }
    },
    mounted() {
        const that = this;

        setTimeout(() => {
            if(!that.submitSuccess) {
                that.showLogFailHelp = true;
            }
        }, 10000);
    }
}
</script>

<style lang="css" scoped>
.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
.btn-theme {
    min-width: 200px;
    border-radius: 20px;
}
</style>
